export class ModalSizeSettings {
	public xsmall: string = '250px';
	public small: string = '500px';
	public medium: string = '750px';
	public large: string = '1050px';
	public xlarge: string = '1750px';
	public full: string = '80%';
	public half: string = '50%';
}